module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-sheet', {
    staticClass: "d-flex align-center justify-center",
    attrs: {
      "height": "100vh",
      "width": "100%",
      "color": "transparent"
    }
  }, [_c('v-sheet', {
    staticClass: "d-flex align-center justify-center",
    attrs: {
      "height": "100vh",
      "width": "400px",
      "color": "transparent"
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl text-center px-4 py-12 overflow-auto",
    attrs: {
      "max-height": "80%"
    }
  }, [_c('v-avatar', {
    staticClass: "ma-1",
    attrs: {
      "size": 164,
      "color": "grey lighten-5"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.logoUrl,
      "lazy-src": ''
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function() {
        return [_c('v-row', {
          staticClass: "fill-height ma-0",
          attrs: {
            "align": "center",
            "justify": "center"
          }
        }, [_c('v-progress-circular', {
          attrs: {
            "indeterminate": ""
          }
        })], 1)]
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v(_vm._s(_vm.route))]), _vm._v(" "), (_vm.route === 'Anmelden') ? _c('signinForm') : _vm._e(), _vm._v(" "), (_vm.route === 'Registrieren') ? _c('signupForm') : _vm._e(), _vm._v(" "), (_vm.route === 'Passwort vergessen') ? _c('updatePasswordForm') : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d4b0236"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/SigninCard.vue
// module id = 740
// module chunks = 15